import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { memo, useMemo } from 'react';
import { useThermometer } from '../../panels/thermometers/thermometer-card/provider';
import { getPointVehiclePosition, isTooDarkVehicleColor, } from '../../panels/vehicle-panel/components/model-view/models/utils';
import { useDesignPackage } from 'console/shared/hooks/helpers';
export const VehicleIndicator = memo(function VehicleIndicator(props) {
    const { title, value, icon, onClick, unit } = props;
    return (_jsx(Tooltip, { title: title, children: _jsxs(Box, { display: "flex", columnGap: 0.5, alignItems: "center", onClick: onClick, children: [_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", fontSize: "1.5rem", children: icon }), _jsxs(Typography, { color: "textSecondary", whiteSpace: "nowrap", children: [value, " ", unit] })] }) }));
});
export const VehicleThermometerIndicator = memo(function VehicleThermometerIndicator(props) {
    const { is_mirrored, icon, position, color, fontColor } = props;
    const { temperature, name } = useThermometer();
    const theme = useTheme();
    const allow_design_package = useDesignPackage();
    const isTooDark = isTooDarkVehicleColor(theme, color);
    const text_color = useMemo(() => {
        if (allow_design_package) {
            return isTooDark ? '#fff' : '#333';
        }
        else {
            return isTooDark ? 'common.white' : 'text.secondary';
        }
    }, [allow_design_package, isTooDark]);
    return (_jsx(Tooltip, { title: `Температура ${name}`, children: _jsxs(Box, { position: "absolute", display: "flex", left: `${getPointVehiclePosition(position.left, is_mirrored)}%`, top: `${getPointVehiclePosition(position.top, is_mirrored)}%`, flexDirection: is_mirrored ? 'row-reverse' : 'row', zIndex: 100, alignItems: "center", columnGap: 0.5, sx: {
                transform: 'translate(-50%, -50%)',
            }, children: [icon || (_jsx(Box, { width: 10, height: 10, borderRadius: "50%", border: `1px solid ${text_color}`, bgcolor: 'primary.main' })), _jsxs(Typography, { color: fontColor ? fontColor : text_color, fontSize: "0.7em", children: [temperature, "\u00B0"] })] }) }));
});
